const HSV_COLOR_SEGMENTS = 6;
const RGB_MAX_VALUE = 255;

// HSV segment indices (0-5 for 6 segments in HSV color wheel)
// eslint-disable-next-line no-magic-numbers
const HSV_SEGMENT_INDICES = [0, 1, 2, 3, 4, 5] as const;

export function hsvToRgb(h: number, s: number, v: number): { r: number; g: number; b: number } {
	let r = 0,
		g = 0,
		b = 0;

	const i = Math.floor(h * HSV_COLOR_SEGMENTS);
	const f = h * HSV_COLOR_SEGMENTS - i;
	const p = v * (1 - s);
	const q = v * (1 - f * s);
	const t = v * (1 - (1 - f) * s);

	switch (i % HSV_COLOR_SEGMENTS) {
		case HSV_SEGMENT_INDICES[0]: // Red to Yellow
			r = v;
			g = t;
			b = p;
			break;
		case HSV_SEGMENT_INDICES[1]: // Yellow to Green
			r = q;
			g = v;
			b = p;
			break;
		case HSV_SEGMENT_INDICES[2]: // Green to Cyan
			r = p;
			g = v;
			b = t;
			break;
		case HSV_SEGMENT_INDICES[3]: // Cyan to Blue
			r = p;
			g = q;
			b = v;
			break;
		case HSV_SEGMENT_INDICES[4]: // Blue to Magenta
			r = t;
			g = p;
			b = v;
			break;
		case HSV_SEGMENT_INDICES[5]: // Magenta to Red
			r = v;
			g = p;
			b = q;
			break;
	}

	return {
		r: Math.round(r * RGB_MAX_VALUE),
		g: Math.round(g * RGB_MAX_VALUE),
		b: Math.round(b * RGB_MAX_VALUE),
	};
}
